import { FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';

export const SitecoreFormFieldIds = {
	hidden: <FieldTypes>'{B67C70C1-6776-4BCB-8529-AA28E02F6412}',
	rawHTML: <FieldTypes>'{F6ABF2D4-D864-48D7-A464-75025A42162E}',
	reCaptcha: <FieldTypes>'{E383BDE2-BC88-4278-83EF-832A15C9E94A}',
};
